const projectList = [
  {
    id: 1,
    section: "mini3",
    name: "FarmFrame",
    github: "https://github.com/puentebravo/FarmFrame",
    img: "./images/farmframeScreen.png",
    deployed: "https://www.farmframe.pro",
    description:
      "Love Warframe, but not sure where to get that thing you need to build the other thing? FarmFrame is here to save the day. Powered by python and hooked directly into the WarFrame API, FarmFrame enables easy lookup of drop locations for nearly every item in the game, as well as information on warframes, weapons, and mods. Need more information? Each result also links to the wiki, so a deeper dive down the rabbit hole is never far away. Farm smarter, not harder!",
    code: "Python/Flask/jinja2/Docker/HTML5/CSS3/JavaScript/Azure/NginX/",
  },
  {
    id: 2,
    section: "mini1",
    name: "Trackit: Between Meeting Fitness",
    github: "https://github.com/puentebravo/trackit",
    img: "./images/trackIt.png",
    deployed: "https://www.meetsweats.lol",
    description:
      "Trackit is fitness for the busy. Have a few minutes between meetings? Before lunch? Just finished a task, and have some downtime before the next one? Make the most of these small moments. Powered by Langchain and OpenAI, Trackit puts a fitness coach in your pocket, allowing you to blend exercise seamlessly into your day.",
    code: "LangChain/React/TypeScript/Express/Docker",
  },
];

export default projectList;
